export default function setLoadMore(className) {
  const domain = window.location.origin;
  const iconPath = `${domain}/wp-content/themes/upsurge/dist/images/icons/loader.svg`;

  const icon1 = document.createElement('IMG');
  icon1.setAttribute('src', iconPath);
  icon1.setAttribute('alt', '');
  icon1.setAttribute('width', 19);
  icon1.setAttribute('height', 19);

  const icon2 = document.createElement('IMG');
  icon2.setAttribute('src', iconPath);
  icon2.setAttribute('alt', '');
  icon2.setAttribute('width', 19);
  icon2.setAttribute('height', 19);

  const icons = [icon1, icon2];

  const buttons = document.querySelectorAll(className);
  if (!buttons || !buttons.length) return;

  [...buttons].forEach((button, index) => {
    const inner = button.querySelector('span');

    if (inner) {
      inner.before(icons[index]);
    } else {
      button.append(icons[index]);
    }
  });
}
